export default "__VITE_ASSET__e82a0101__"